import { deepCompare } from "@website/utils/deep-compare";
import { numberConvert } from "@website/utils/number-convert";
import checkCircleOutline from "@website/widget/reserve-rate/reserve-rate-footer/assets/check-circle-outline.svg";
import { ReserveRateFooterPropertiesTypes } from "@website/widget/reserve-rate/reserve-rate-footer/reserve-rate-footer.types";
import { useRouter } from "next/router";
import { memo } from "react";

const limitOfferCount = 1_000_000;
const Component = ({
  properties
}: {
  properties: ReserveRateFooterPropertiesTypes;
}) => {
  const { offerCount, offerMessage } = properties;
  const router = useRouter();

  return (
    <div className="bg-transparent-success text-body-2 mt-4 flex flex-row items-center justify-start gap-2 rounded-[8px] p-4 md:w-full lg:max-w-[1200px]">
      <img alt="checked" className="size-6" src={checkCircleOutline?.src} />
      <span>
        {offerMessage ??
          `${
            Number(offerCount) < 1_000_000
              ? numberConvert(offerCount, {
                  locale: router.locale
                })
              : numberConvert(limitOfferCount, { locale: router.locale })
          } مسافر اخیر این اقامتگاه را پیشنهاد داده اند.`}
      </span>
    </div>
  );
};
export const ReserveRateFooter = memo(Component, deepCompare);
